export default __webpack_public_path__ + "24a0b70b6bcb584d2f070860711c8cf2.jpg";